<itl-wizard-page
  *ngIf="form"
  pageTitleTransPath="Artikel bearbeiten"
  [isSinglePage]="true"
  [pageIsValid]="true"
  (doneClicked)="save()"
  (cancelClicked)="cancel()"
>
  <div class="content">
    <div class="section-title bold">
      {{ 'order.edit.articleInfo' | translate }}
    </div>
    <itl-integratedcare-article
      [article]="articleLine.article"
      [icon]="'alberta-article'"
      [hideChevron]="true"
    ></itl-integratedcare-article>
    <div class="section-title bold">{{ 'order.edit.quantity' | translate }}</div>
    <div class="currentAmount bold" *ngIf="articleLine?.packagingUnit; else warningDefectPackagingUnit">
      {{ articleLine?.quantity }} {{ articleLine?.unit | articleUnitPipe }} ({{ articleLine?.packagingUnit.quantity }}
      {{ 'order.edit.unit' | translate }})
    </div>
    <ng-template #warningDefectPackagingUnit
      ><itl-info-box [type]="1">{{
        'careproposal.create.shoppingCart-listitems.warningDefectPackagingUnit' | translate
      }}</itl-info-box></ng-template
    >
    <div class="chips">
      <itl-change-amount
        [header]="'order.edit.amount' | translate"
        [selectedPackagingUnit]="articleLine?.packagingUnit"
        [value]="articleLine?.quantity"
        (valueChange)="articleLine.quantity = $event"
        (minusClicked)="deleteOne()"
        (plusClicked)="addOne()"
        (selectClicked)="openUnitSelect()"
      ></itl-change-amount>
    </div>
    <div>
      <div class="section-title bold" *ngIf="showBatchNumber || showSerialNumber">
        {{ 'order.edit.identificationNumbers' | translate }}
      </div>
      <itl-text
        *ngIf="showBatchNumber"
        title="Chargennummer"
        icon="alberta-customer-number"
        type="text"
        [(ngModel)]="articleLine.batchNumber"
        [formControl]="batchNumber"
      ></itl-text>
      <itl-text
        *ngIf="showSerialNumber"
        title="Seriennummer"
        icon="alberta-customer-number"
        type="text"
        [(ngModel)]="articleLine.serialNumber"
        [formControl]="serialNumber"
      ></itl-text>
    </div>
    <div *ngIf="(!showResmedTenant && !isDirectOrder) || storageLocations?.length">
      <div class="section-title bold">
        {{ 'order.edit.other' | translate }}
      </div>
      <div *ngIf="!showResmedTenant && !isDirectOrder">
        <div class="others-privateSale">
          <div class="privateSale-checkbox">
            <ion-checkbox
              (ionChange)="togglePrivateSaleCheckbox($event, articleLine)"
              [checked]="articleLine.isPrivateSale"
            ></ion-checkbox>
          </div>
          <div class="privateSale-checkbox-label bold">{{ 'article.edit.individual.isPrivateSale' | translate }}</div>
        </div>
      </div>
      <itl-selection
        *ngIf="storageLocations?.length"
        [title]="'article.edit.individual.storageLocation' | translate"
        [(ngModel)]="articleLine.storageLocation"
        [values]="storageLocations"
        [formControl]="storageLocation"
      ></itl-selection>
    </div>
    <div class="deleteButtonWrapper" *ngIf="showDeleteArticleButton">
      <itl-button id="deleteButton" (click)="removeArticleFromShoppingCart()">
        <ion-icon class="deleteButtonIcon" name="alberta-delete"></ion-icon>
        {{ 'careproposal.create.shoppingCart-listitems.deleteArticle' | translate }}
      </itl-button>
    </div>
  </div>
</itl-wizard-page>
